var _a;
export const crmToken = (_a = process.env.CRM_TOKEN) !== null && _a !== void 0 ? _a : "5oe00emr75q";
export function getPrivateSubmissionAppOrigin() {
    const origin = process.env.PRIVATE_SUBMISSION_URL;
    if (!origin) {
        return "";
    }
    try {
        return new URL(origin).origin;
    }
    catch {
        return "";
    }
}
export function privateSubmissionUrl(path) {
    const origin = getPrivateSubmissionAppOrigin().replace(/\/$/, "");
    if (!origin) {
        return "";
    }
    if (!crmToken) {
        return "";
    }
    return `${origin}/private-submission/${path}?crm_token=${crmToken}`;
}
